var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"id":"map"}},[_c('v-row',[_c('v-col',{staticClass:"d-none d-md-inline ma-0 col-search",attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('ListResMap')],1),_c('v-col',{staticClass:"mr-auto pa-0",attrs:{"cols":"12","sm":"12","md":"8","lg":"9","id":"col-map"}},[_c('MainMap')],1),_c('DialogEntity'),_c('DialogResMap')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }